
import { namespace } from 'vuex-class'
import { Vue, Component, Prop  } from 'vue-property-decorator'
import * as catalog from '~/store/modules/catalog'
import * as sq from '~/store/modules/sq'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

const Catalog = namespace(catalog.name)
const SQ = namespace(sq.name)

@Component({
  components: {
    PlanIcon1: () => import('~/components/Icons/PlanIcon1.vue'),
    PlanIcon2: () => import('~/components/Icons/PlanIcon2.vue'),
    PlanIcon3: () => import('~/components/Icons/PlanIcon3.vue'),
    PlanIcon4: () => import('~/components/Icons/PlanIcon4.vue'),
    Tick: () => import('~/components/Icons/Tick.vue'),
    VueSlickCarousel: () => import('vue-slick-carousel')
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand,
      informationSummaries: process.env.informationSummaries,
      carouselKey: 0
    }
  },
  watch: {
    planGroup(value) {
      this.carouselKey = value
    }
  },
  methods: {
    getGroupName(group: string): string {
      if (group === 'Business Asymmetrical') {
        return 'Asymmetrical speed plans'
      } if (group === 'Business Symmetrical') {
        return 'Symmetrical speed plans'
      }

      return ''
    },
    planDescription(download: number, upload: number): string {
      let string = 'Tailor the bandwidth to suit your business.'
      
      if ((download === 250 && upload === 25) || (download === 200 && upload === 200))
        string = 'Reliable performance for uninterrupted operations'
      if (download === 1000 && upload === 50)
        string = 'Stay ahead of the curve with lightning-fast connectivity'
      if (download === 500 && upload === 100)
        string = 'Empower your Business with robust network stability'
      if (download === 1000 && upload === 400)
        string = 'Unleash maximum performance for your enterprise'
      return string
    },
    getPlanUsers(download: number, upload: number): string {
      let string = '5'

      if (download === 250 || download === 200)
        string = '15'
      if (download === 1000 && upload === 50)
        string = '20'
      if (download === 500 && upload === 100)
        string = '20'
      if (download === 1000 && upload === 400)
        string = '50'
      return string
    },
    getPlanSuitedFor(download: number, upload: number): string {
      let string = 'HD Streaming and video conferencing.'

      if ((download === 250 && upload === 25) || (download === 200 && upload === 200))
        string = 'Impressive UHD Video capabilities and reliable performance'
      if (download === 1000 && upload === 50)
        string = 'Large file transfers and simultaneous UHD streaming'
      if (download === 500 && upload === 100)
        string = 'Real-time collaboration, UHD video conferencing and large file transfers'
      if (download === 1000 && upload === 400)
        string = 'Consistent fast speeds for multiple users, collaborative cloud computing and data-intensive tasks'
      return string
    },
    planIcon(download: number): string {
      let string = ''

      if (download === 250) string = 'PlanIcon2'
      if (download === 400) string = 'PlanIcon3'
      if (download === 1000) string = 'PlanIcon4'
      return string
    },
    buttonBackground(featured: boolean, type: string): string {
      if (type === 'Business') {
        return featured ? 'bg-secondary' : 'bg-brand-colour-alt'
      }
      return featured ? 'bg-brand-colour-alt' : 'bg-brand-colour-alt'
    },
    containerHeight(featured: boolean): string {
      return featured ? 'mt-18' : 'mt-8'
    },
    iconColour(featured: boolean, type: string): string {
      if (type === 'Business') {
        return featured ? 'text-secondary' : 'text-black'
      }
      return featured ? 'text-brand-colour-alt' : 'text-black'
    },
    cisLinkColour(featured: boolean, type: string): string {
      if (type === 'Business') {
        return featured ? 'text-secondary' : 'text-primary'
      }
      return featured ? 'text-pink' : 'text-primary'
    },
    formatPrice(price): any {
      let fp = price.toString().split('.')
      if (fp[1] === undefined) {
        fp[1] = '00'
      }
      fp = `$${fp[0]}<small class="align-top text-xl">.${fp[1]}</small>`
      return fp
    }
  }
})
export default class PlanCardBusinessBundle extends Vue {
  @Prop({ default: 'Business Asymmetrical' })
  planGroup: string | null

  @Catalog.Getter
  businessBundles

  @Catalog.Getter
  businessPlanGroups

  @SQ.Mutation
  updatePrimaryNetwork

  @SQ.Getter
  defaultNetworks

  @Catalog.Action
  fetchAllProducts


  mobileSettings = [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      initialSlide: 2,
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    }
  }
  ]

  async created() {
    this.planGroup = 'Business Asymmetrical'
    await this.updatePrimaryNetwork(
      this.defaultNetworks.filter(network => network.carrierCode === 'OC')[0]
    )
    await this.fetchAllProducts()
  }

  changePlanGroup(grp) {
    this.planGroup = grp;
  }

  getFilteredPlans() {
    if (this.businessBundles) {      
      return this.businessBundles.filter(pl => pl.catalogGroup === this.planGroup)
    }

    return null
  }

  get businessCISFile(): string {
    return this.planGroup === 'Business Symmetrical'
      ? 'Uniti Internet - Critical Information Summary - Business Symmetrical.pdf'
      : 'Uniti Internet - Critical Information Summary - Business Asymmetrical.pdf'
  }
}
